import { RootState } from "../../utils/types"

export const tagsSelector = (state: RootState) =>
  state.tags.map

export const tagsStatusSelector = (state: RootState) => state.tags.status;